module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/artillery-battalion-lvl3-75.d84fd06f.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/artillery-battalion-lvl3-75.png
// module id = 3504
// module chunks = 11